import { render, staticRenderFns } from "./AlertSuccess.vue?vue&type=template&id=0a3cb273&scoped=true&"
import script from "./AlertSuccess.vue?vue&type=script&lang=js&"
export * from "./AlertSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AlertSuccess.vue?vue&type=style&index=0&id=0a3cb273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3cb273",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
